export const SHARE_CHANNELS = [
  "copy",
  "sms",
  "email",
  "facebook",
  "x",
  "linkedin",
  "whatsapp",
  "instagram",
  "tiktok",
] as const;

export type ShareChannel = (typeof SHARE_CHANNELS)[number];

export const SHARE_CHANNEL_LABELS: Record<ShareChannel, string> = {
  copy: "Copy link",
  sms: "Text message",
  email: "Email",
  facebook: "Facebook",
  x: "X",
  linkedin: "LinkedIn",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  tiktok: "TikTok",
};

export const DEFAULT_SHARE_CHANNELS: ShareChannel[] = [
  "copy",
  "sms",
  "email",
  "facebook",
  "x",
];

export function normalizeShareChannels(value?: string[] | null): ShareChannel[] {
  if (!value) return DEFAULT_SHARE_CHANNELS;
  const allowed = SHARE_CHANNELS as readonly string[];
  const cleaned = value.filter((c): c is ShareChannel => allowed.includes(c));
  return cleaned;
}

export const PUBLIC_SITE_ORIGIN = "https://volunteer.t1dw.org";
/**
 * Public volunteer landing page on the main site. Every recruiting link
 * (invite funnel, referral emails, text messages) points here, not at the app.
 */
export const VOLUNTEER_LANDING_URL = "https://t1dw.org/volunteer";
const SHARE_IMAGE_PATH = "/api/public/event-share-image/";

export function normalizeShareImageUrl(value?: string | null) {
  const raw = (value ?? "").trim();
  if (!raw) return null;
  if (raw.startsWith(SHARE_IMAGE_PATH)) return raw.slice(0, 500);
  try {
    const url = new URL(raw);
    if (url.protocol !== "https:") return null;
    // Uploaded images are stored as a site-relative path so previews always
    // resolve against the live domain, never an ephemeral preview host.
    if (url.pathname.startsWith(SHARE_IMAGE_PATH)) return url.pathname.slice(0, 500);
    return url.toString().slice(0, 500);
  } catch {
    return null;
  }
}

/** Absolute, crawler-fetchable URL for an event share image. */
export function resolveShareImageUrl(value?: string | null) {
  const normalized = normalizeShareImageUrl(value);
  if (!normalized) return null;
  return normalized.startsWith("/") ? `${PUBLIC_SITE_ORIGIN}${normalized}` : normalized;
}


export function defaultShareMessage(title: string, url: string) {
  return `Volunteer with T1D Warriors at ${title}. Claim a spot here: ${url}`;
}
